import React from 'react';
import SharedUnavailableCard from '../UnavailableCard';
import solar_unavailable from '../../../assets/animations/unavailable/solar.gif';

const UnavailableCard = () => (
  <SharedUnavailableCard
    badge="Not integrated"
    title="Solar systems not yet integrated"
    message="Solar systems are not yet built or operational. This EMS tool will support solar integration once the systems are developed and integrated."
    image={solar_unavailable}
  />
);

export default UnavailableCard;
